export enum IETM_FIGURE_VIEW_MODE {
  FIGURE = 'figure',
  WIRE = 'wire',
  THREE = 'three',
  SNSTHREE = 'snsthree'
}
